import styled from 'styled-components';

export const TitleApp = styled.h1`
	color: ${props => props.theme.text};
	margin: 0;
	padding: 2rem 0 0;
`;
